import ACTIONS, { FETCH_STATUS } from "../constants";
  
// SORT DECISION_LOG

export const sortDecisionLogRequest = (state) => ({
  type: ACTIONS.SORT_DECISION_LOG_CALL,
  payload: state,
});

export const sortDecisionLogAttempt = {
  pending: {
    type: ACTIONS.SORT_DECISION_LOG.PENDING,
    status: FETCH_STATUS.LOADING,
  },
  success: (data) => ({
    type: ACTIONS.SORT_DECISION_LOG.SUCCESS,
    data,
    status: FETCH_STATUS.SUCCESS,
  }),
  error: (error) => ({
    type: ACTIONS.SORT_DECISION_LOG.ERROR,
    error,
    status: FETCH_STATUS.ERROR,
  }),
};

// GET DECISION_LOG

export const getDecisionLogRequest = (state) => ({
  type: ACTIONS.DECISION_LOG_CALL,
  payload: state,
});

export const getDecisionLogAttempt = {
  pending: {
    type: ACTIONS.DECISION_LOG.PENDING,
    status: FETCH_STATUS.LOADING,
  },
  success: (data) => ({
    type: ACTIONS.DECISION_LOG.SUCCESS,
    data,
    status: FETCH_STATUS.SUCCESS,
  }),
  error: (error) => ({
    type: ACTIONS.DECISION_LOG.ERROR,
    error,
    status: FETCH_STATUS.ERROR,
  }),
};

// CREATE DECISION_LOG

export const createDecisionLogRequest = (state) => ({
  type: ACTIONS.CREATE_DECISION_LOG_CALL,
  payload: state,
});

export const createDecisionLogAttempt = {
  pending: {
    type: ACTIONS.CREATE_DECISION_LOG.PENDING,
    status: FETCH_STATUS.LOADING,
  },
  success: (data) => ({
    type: ACTIONS.CREATE_DECISION_LOG.SUCCESS,
    data,
    status: FETCH_STATUS.SUCCESS,
  }),
  error: (error) => ({
    type: ACTIONS.CREATE_DECISION_LOG.ERROR,
    error,
    status: FETCH_STATUS.ERROR,
  }),
};

// UPDATE DECISION_LOG

export const updateDecisionLogRequest = (state) => ({
  type: ACTIONS.UPDATE_DECISION_LOG_CALL,
  payload: state,
});

export const updateDecisionLogAttempt = {
  pending: {
    type: ACTIONS.UPDATE_DECISION_LOG.PENDING,
    status: FETCH_STATUS.LOADING,
  },
  success: (data) => ({
    type: ACTIONS.UPDATE_DECISION_LOG.SUCCESS,
    data,
    status: FETCH_STATUS.SUCCESS,
  }),
  error: (error) => ({
    type: ACTIONS.UPDATE_DECISION_LOG.ERROR,
    error,
    status: FETCH_STATUS.ERROR,
  }),
};

// DELETE DECISION_LOG

export const deleteDecisionLogRequest = (state) => ({
  type: ACTIONS.DELETE_DECISION_LOG_CALL,
  payload: state,
});

export const deleteDecisionLogAttempt = {
  pending: {
    type: ACTIONS.DELETE_DECISION_LOG.PENDING,
    status: FETCH_STATUS.LOADING,
  },
  success: (data) => ({
    type: ACTIONS.DELETE_DECISION_LOG.SUCCESS,
    data,
    status: FETCH_STATUS.SUCCESS,
  }),
  error: (error) => ({
    type: ACTIONS.DELETE_DECISION_LOG.ERROR,
    error,
    status: FETCH_STATUS.ERROR,
  }),
};

// FLAG DECISION_LOG

export const updateDecisionLogFlag = (state) => ({
  type: ACTIONS.DECISION_LOG_FLAG_CALL,
  payload: state,
});

export const updateDecisionLogFlagAttempt = {
  pending: {
    type: ACTIONS.DECISION_LOG_FLAG.PENDING,
    status: FETCH_STATUS.LOADING,
  },
  success: (data) => ({
    type: ACTIONS.DECISION_LOG_FLAG.SUCCESS,
    data,
    status: FETCH_STATUS.SUCCESS,
  }),
  error: (error) => ({
    type: ACTIONS.DECISION_LOG_FLAG.ERROR,
    error,
    status: FETCH_STATUS.ERROR,
  }),
}; 